<template>
  <div class="amap-wrapper">
    <el-amap
      class="amap-box"
      vid="task-amap"
      :amap-manager="amapManager"
      :zoom="12"
      :center="center"
      :expand-zoom-range="true"
    />
  </div>
</template>

<script>
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
import poiMarker from "@/assets/poi-marker.png";

const amapManager = new AMapManager();
let map, polyline, layer, driver, geocoder;
export default {
  name: "TaskMap",
  props: {
    path: {
      type: Array,
      default: () => {
        return [];
      },
    },
    center: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    amapManager,
  }),
  watch: {
    path() {
      this.initAMap();
    },
  },
  mounted() {
    this.initAMap();
  },
  methods: {
    initAMap() {
      lazyAMapApiLoaderInstance.load().then(() => {
        map = amapManager.getMap();
        this.drawLine();
      });
    },
    drawLine() {
      if (!this.path.length) {
        return;
      }
      const lineArr = Array.from(this.path);

      if (!map) {
        map = amapManager.getMap();
      }

      console.log("map", map);

      if (polyline) {
        polyline.setMap(null);
      }
      polyline = new AMap.Polyline({
        map: map,
        path: lineArr,
        showDir: true,
        strokeColor: "#28F", //线颜色
        strokeWeight: 6, //线宽
      });
      map.setFitView();
      this.drawLayer();
    },
    drawDriver() {
      if (!this.path.length) {
        return;
      }
      const lineArr = Array.from(this.path);

      if (!map) {
        map = amapManager.getMap();
      }

      if (driver) {
        driver.setMap(null);
      }

      driver = new AMap.TruckDriving({
        map: map,
        size: 4,
        showTraffic: false,
        hideMarkers: true,
        policy: 5,
      });

      driver.search(
        lineArr.map((path) => {
          return {
            lnglat: path,
          };
        }),
        (status, result) => {
          if (status === "complete") {
            map.setFitView();
            this.drawLayer();
          } else {
            console.error("路线规划错误，错误原因：", result);
            console.warn("采用备选方案，使用路径点规划线条");
            this.drawLine();
          }
        }
      );
    },
    lntlatToAddress(lntlat) {
      if (!geocoder) {
        geocoder = new AMap.Geocoder();
      }
      return new Promise((resolve, reject) => {
        geocoder.getAddress(lntlat, (status, result) => {
          if (status === "complete") {
            const { province, city, district, township } =
              result.regeocode.addressComponent;
            resolve([province, city, district, township].join(""));
          } else {
            reject(result);
          }
        });
      });
    },
    async drawLayer() {
      if (!this.path.length) {
        return;
      }
      const firstPath = this.path[0];
      const lastPath = this.path.slice(-1)[0];

      const renderLayer = [firstPath, lastPath];

      if (!map) {
        map = amapManager.getMap();
      }
      if (layer) {
        layer.setMap(null);
      }
      layer = new AMap.LabelsLayer({
        zooms: [3, 20],
        zIndex: 1000,
      });
      map.add(layer);
      renderLayer.forEach(async (path, index) => {
        const startInfo = {
          clipOrigin: [280, 7],
          textBg: "#5591f5",
        };
        const endInfo = {
          clipOrigin: [716, 7],
          textBg: "#e05140",
        };

        const name = await this.lntlatToAddress(path.join(","));
        const labelMarker = new AMap.LabelMarker({
          name,
          position: path,
          zooms: [4, 24],
          zIndex: 2,
          opacity: 1,
          icon: {
            type: "image",
            image: poiMarker,
            clipOrigin: index === 0 ? startInfo.clipOrigin : endInfo.clipOrigin,
            clipSize: [50, 68],
            size: [25, 34],
            anchor: "bottom-center",
            angel: 0,
            retina: true,
          },
          text: {
            content: name,
            direction: "top",
            offset: [0, 0],
            style: {
              fontSize: 12,
              fontWeight: "normal",
              fillColor: "#fff",
              padding: [2, 5, 2, 5],
              backgroundColor: index === 0 ? startInfo.textBg : endInfo.textBg,
            },
          },
          extData: {
            index: 8,
          },
        });

        layer.add(labelMarker);
      });

      map.setFitView();
    },
  },
};
</script>

<style>
.amap-box {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>